export default function Footer() {
  const footerLinks = {
    services: [
      { name: 'Power Wheelchair Repair', href: '#service-overview' },
      { name: 'Medical Scooter Service', href: '#service-overview' },
      { name: 'Hospital Bed Repair', href: '#service-overview' },
      { name: 'Lift Chair Maintenance', href: '#service-overview' }
    ],
    areas: [
      { name: 'New York City', href: '#areas-served' },
      { name: 'Westchester County', href: '#areas-served' },
      { name: 'Long Island (Nassau & Suffolk)', href: '#areas-served' },
      { name: 'New Jersey', href: '#areas-served' },
      { name: 'Connecticut', href: '#areas-served' }
    ],
    company: [
      { name: 'About Us', href: '#about-us' },
      { name: 'Contact', href: '#request-form' },
      { name: 'Request Service', href: '#request-form' },
      { name: 'Emergency Repairs', href: '#request-form' }
    ],
    resources: [
      { name: 'FAQs', href: '#faq-section' },
      { name: 'Service Areas', href: '#areas-served' },
      { name: 'Insurance Info', href: '#faq-section' },
      { name: 'Warranty Policy', href: '#faq-section' }
    ]
  };

  return (
    <footer className="bg-gray-50 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Top Footer - Navigation Grid */}
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          {/* Services */}
          <div>
            <h4 className="text-gray-900 font-bold text-lg mb-4 border-b-2 border-[#14B8A6] inline-block pb-1">
              Services
            </h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    className="text-gray-600 hover:text-[#14B8A6] transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-gray-900 font-bold text-lg mb-4 border-b-2 border-[#14B8A6] inline-block pb-1">
              Service Areas
            </h4>
            <ul className="space-y-3">
              {footerLinks.areas.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    className="text-gray-600 hover:text-[#14B8A6] transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-gray-900 font-bold text-lg mb-4 border-b-2 border-[#14B8A6] inline-block pb-1">
              Company
            </h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    className="text-gray-600 hover:text-[#14B8A6] transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-gray-900 font-bold text-lg mb-4 border-b-2 border-[#14B8A6] inline-block pb-1">
              Resources
            </h4>
            <ul className="space-y-3">
              {footerLinks.resources.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    className="text-gray-600 hover:text-[#14B8A6] transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 mb-8"></div>

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-2">
              <img 
                src="https://public.readdy.ai/ai/img_res/ae5459f1-d3db-4325-ac3a-08ac7b19695d.png" 
                alt="Independence Medical Equipment" 
                className="h-10 w-auto object-contain"
              />
              <div>
                <p className="text-2xl font-bold text-[#1e3a5f]">Independence</p>
                <p className="text-lg text-gray-600">Medical Equipment</p>
              </div>
            </div>
            <div className="h-1 w-24 bg-[#14B8A6] mb-2"></div>
            <p className="text-sm text-gray-500">Licensed &amp; Insured</p>
          </div>

          {/* Copyright & Social */}
          <div className="text-center md:text-right">
            <p className="text-gray-500 text-sm mb-4">
              © {new Date().getFullYear()} Independence Medical Equipment. All rights reserved.
            </p>
            <div className="flex gap-4 justify-center md:justify-end">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-[#1e3a5f] text-gray-600 hover:text-white transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-[#1e3a5f] text-gray-600 hover:text-white transition-all cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-[#1e3a5f] text-gray-600 hover:text-white transition-all cursor-pointer"
              >
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a 
                href="https://google.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-[#1e3a5f] text-gray-600 hover:text-white transition-all cursor-pointer"
              >
                <i className="ri-google-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}